import { module } from 'modujs';
import { Swiper, Navigation, Pagination, Autoplay } from 'swiper';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        Swiper.use([Navigation, Pagination, Autoplay]);

        this.length = this.$('item').length
        this.container = this.$('container')[0];
        this.pagination = this.$('pagination')[0];

        const args = {
            speed: 700,
            loop: true,
            spaceBetween: 30,
            grabCursor: true,
            autoplay: {
                delay: 5000,
            },
            pagination: {
                el: this.pagination,
                type: 'bullets',
                clickable: true
            }
        }

        if(this.length > 1) {
            this.carousel = new Swiper(this.container, args)
        } else {
            this.container.classList.add('-no-slide')
        }
    }

    destroy() {
        if(this.carousel && this.carousel.destroy) this.carousel.destroy()
    }
}
